import { Injectable } from '@angular/core';

import { ParticipationPanelCommonService } from '@app/core/games-service';
import { ParticipationPanelEngine } from '@app/widgets/participation-panel';

// онли для легаси фаста
@Injectable()
export class ParticipationPanelService extends ParticipationPanelCommonService implements ParticipationPanelEngine {}
